var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonVariationView',{attrs:{"type":"variation","reporter":"employer","contract":_vm.contract,"items":_vm.items,"form-fields":_vm.formFields},on:{"FETCH_DATA":_vm.handleFetchData}})
}
var staticRenderFns = []

export { render, staticRenderFns }